import { render, staticRenderFns } from "./UserPhoneInput.vue?vue&type=template&id=1d34fbf0&"
import script from "./UserPhoneInput.vue?vue&type=script&lang=ts&"
export * from "./UserPhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./UserPhoneInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports